import { Typography } from '@mui/material';

import { FormDialog } from './FormDialog';

type ConfirmDialogProps = {
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onClose: () => void;
  isBusy?: boolean;
  error?: unknown;
};

/** An action that cannot be taken back asks once, in words that say what will happen. */
export const ConfirmDialog = ({
  title,
  message,
  confirmLabel,
  onConfirm,
  onClose,
  isBusy,
  error,
}: ConfirmDialogProps) => (
  <FormDialog
    title={title}
    onClose={onClose}
    onSubmit={onConfirm}
    submitLabel={confirmLabel}
    isBusy={isBusy}
    error={error}
    maxWidth="xs"
  >
    <Typography variant="body2">{message}</Typography>
  </FormDialog>
);
